<template>
    <div>
        <a @click.stop.prevent="deleteProfileConfirmation" href="/abc.html">Profil löschen</a>
        <!-- Modal -->
        <div ref="modalConfirmation" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bestätigung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Möchtest du dein Profil wirklich löschen?
                    <p>Bitte beachte: du kannst diesen Schritt nicht rückgängig machen. All deine Profildaten und Beiträge werden gelöscht und sind damit unwiderruflich verloren.</p>
                </div>
                <div class="modal-footer">
                    <button @click="deleteProfile" type="button" class="btn btn-secondary" data-dismiss="modal">Ja</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Nein</button>
                </div>
                </div>
            </div>
        </div>
        <div ref="modalSuccess" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bestätigung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Dein Profil wurde gelöscht!
                </div>
                <div class="modal-footer">
                    <button @click="gotoHome" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import Modernizr from 'modernizr';
	export default {
		name: 'profileDeleter',
		props: {
            profileId: String
        },
        data: function() {
        	return {
                isTouch: false
        	}
        },
        created: function() {
            if (Modernizr.touchevents) {
                this.isTouch = true;
            }
        },
        methods: {
            deleteProfileConfirmation: function() {
                jQuery(this.$refs.modalConfirmation).modal('show');
                return false;
            },
            deleteProfile: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/profile/' + self.profileId,
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        jQuery(self.$refs.modalSuccess).modal('show');
                    },
                    error: function() {alert("error");}
                });
            },
            gotoHome: function() {
                window.location.href = '/home.html';
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileDeleter.vue?3c8e52f5